
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './QualityTileComp.module.css';

const QualityTileComp = ({ title, value }) => {
  return (
    <div className={styles['stat-tile']}>
      <div className={styles['tile-header']}>{title}</div>
      <div className={styles['tile-body']}>
        <div className={styles['tile-value']}>{value}</div>
      </div>
      <div className={styles['tile-footer']} />
    </div>
  );
};

QualityTileComp.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,

};

QualityTileComp.defaultProps = {
  isPositive: true
};

export default QualityTileComp;
